import React, { useEffect, useState } from "react";
import {
  getCustomerList,
  addCustomer,
  updateCustomer,
} from "../../api/customerApi";
import { useAuth } from "../../context/AuthContext";
const useCustomer = () => {
  const { user } = useAuth();
  const [customers, setCustomers] = useState([]);
  const [customer, setCustomer] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
  });
  const [editCustomer, setEditCustomer] = useState(false);
  const [displayCustomers, setDisplayCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState(false);

  useEffect(() => {
    fetchCustomer();
  }, []);

  const fetchCustomer = async () => {
    var data = await getCustomerList(user.barberShop);
    if (data) {
      setCustomers(data);
      setDisplayCustomers(data);
      setLoading(false);
    } else {
    }
  };

  const onClear = () => {};

  const onEditClick = (c) => {
    setCustomer(c);
    setShowModal(true);
    setEditCustomer(true);
  };
  const onSave = async (customer) => {
    setLoading(true);
    try {
      if (editCustomer) {
        const response = await updateCustomer(customer, user.barberShop);
        if (response.data.isSuccess) {
          setLoading(false);
          setShowModal(false);
          setMessage({ text: response.data.value, type: "success" });
          setShowMessage(true);
          fetchCustomer();
          setCustomer({
            firstName: "",
            lastName: "",
            phoneNumber: "",
            email: "",
          });
          setEditCustomer(false);
        } else {
          setMessage({
            text: response.data.errors.join("\n"),
            type: "danger",
          });
          setShowMessage(true);
          setLoading(false);
          setShowModal(false);
          setCustomer({
            firstName: "",
            lastName: "",
            phoneNumber: "",
            email: "",
          });
          setEditCustomer(false);
        }
      } else {
        // Example API endpoint
        const response = await addCustomer(customer, user.barberShop);
        if (response.data.isSuccess) {
          setLoading(false);
          setShowModal(false);
          setMessage({ text: response.data.value, type: "success" });
          setShowMessage(true);
          fetchCustomer();
        } else {
          setMessage({
            text: response.data.errors.join("\n"),
            type: "danger",
          });
          setShowMessage(true);
          setLoading(false);
          setShowModal(false);
        }
      }
    } catch (err) {
      console.error("Error fetching appointments:", err);
    }
  };
  return {
    loading,
    displayCustomers,
    customer,
    showModal,
    setShowModal,
    onSave,
    onEditClick,
    message,
    showMessage,
    setShowMessage,
  };
};
export default useCustomer;
